import { ReactElement, useEffect, useState } from 'react';
import { NextPageWithLayout } from './_app';
import { Layout } from '@components/Layout';
import Header from '@components/_OldDesign/header';
import ProductDefinitionSection from '@components/eSignature/ProductDefinitionSection/ProductDefinitionSection';
import { CompareSection } from '@components/eSignature/CompareSection';
import { Usage } from '@components/eSignature/Usage';
import { PointerSection } from '@components/eSignature/PointerSection';
import { ServiceSection } from '@components/eSignature/ServiceSection';
import { CustomerSection } from '@components/eSignature/CustomerSection';
import { GetStaticProps } from 'next';
import fetchStrapi from 'lib/fetchStrapi';
import { findContent } from 'utils/translate';
import { FeedBlog } from 'models/Home.model';
import { HomeContext } from '@components/Contexts/HomeContext';
import NewsFeedSection from '@components/NewsFeedSection/NewsFeedSection';
import { FetchHighlightBlogs } from 'utils/fetchHighlightBlogs';
import {
  ESignatureContext,
  ESignatureState,
} from '@components/Contexts/ESignatureContext';
import FormContact from '@components/shared/FormContact';

export interface CustomerProps {
  url: string;
  alt: string;
  width: number;
  height: number;
}

export const getStaticProps: GetStaticProps = async () => {
  try {
    const contents = await fetchStrapi('/e-signatures');
    const highlightBlogs: FeedBlog[] = await FetchHighlightBlogs();

    const customers: CustomerProps[] = findContent(contents, 'Customer')
      ?.subContent.filter((c) => c?.image?.length > 0)
      .map((c) => {
        return {
          url: String(c.image[0]?.url),
          alt: String(c.image[0]?.alternativeText),
          width: Number(c.image[0]?.width),
          height: Number(c.image[0]?.height),
        } as CustomerProps;
      });

    return {
      props: {
        customers,
        highlightBlogs,
      },
    };
  } catch (error) {
    return {
      props: {
        highlightBlogs: [],
        data: JSON.stringify(error),
      },
    };
  }
};

const ESignature: NextPageWithLayout<ESignatureState> = (state) => {
  const [scroll, setScroll] = useState(false);

  const scrollToContact = () => {
    setScroll(!scroll);
  };
  return (
    <>
      <Header
        content={{
          title: 'e-Signature by CODIUM - เซ็นเอกสารดิจิทัลอย่างถูกกฎหมาย',
          content:
            'CODIUM e-Signature ระบบเซ็นเอกสารดิจิทัลที่ปลอดภัย ถูกกฎหมาย 100% ช่วยให้การทำงานสะดวก รวดเร็ว และลดการใช้กระดาษ รองรับการทำงานได้ทุกที่ ทุกเวลา',
          image: null,
        }}
      />
      <ESignatureContext.Provider value={state}>
        <HomeContext.Provider value={state}>
          <ProductDefinitionSection click={scrollToContact} />

          <div className="w-full h-fit bg-white">
            <CompareSection />

            <Usage />
          </div>
          <div className="w-full h-fit bg-white py-10">
            <PointerSection />
          </div>
          <div className="w-full h-fit bg-darkBlue">
            <ServiceSection click={scrollToContact} />
          </div>
          <div className="w-full h-fit bg-white pb-5">
            <CustomerSection contents={state.customers} />
          </div>
          <div className="w-full h-fit bg-white pb-10">
            <NewsFeedSection />
          </div>
          <div className="w-full h-fit text-white">
            <FormContact
              product="E-SIGNATURE"
              event="e-signatureFormSubmit"
              scroll={scroll}
            />
          </div>
        </HomeContext.Provider>
      </ESignatureContext.Provider>
    </>
  );
};

ESignature.getLayout = (page: ReactElement) => {
  return <Layout>{page}</Layout>;
};

export default ESignature;
